import { Icon as FunctionalIcon } from "../../ui/Icon.js";
import { useT } from "../../i18n/index.js";
import { Timer, formatDuration } from "../../ui/Timer.js";
import { baseApi } from "../api.js";
import { useBase } from "../state.js";
import { CostRow, Sheet } from "./shared.js";
import { PayAction } from "./PayAction.js";

/** Reclaimable zones around the core: state, unlock level, cost and timer (R13). */
export function ZonePanel({ onFocus }: { onFocus: (zoneId: string) => void }) {
  const t = useT();
  const base = useBase((s) => s.base);
  const run = useBase((s) => s.run);
  const setPanel = useBase((s) => s.setPanel);
  if (!base) return null;
  return (
    <Sheet title={t("base.zones.title")} onClose={() => setPanel({ kind: "none" })} testId="zone-panel">
      <p className="hint" style={{ marginTop: 0 }}>{t("base.zones.hint")}</p>
      {base.zones.map((z) => {
        const hqOk = base.enclave.hqLevel >= z.unlockHq;
        return (
          <div key={z.id} className="list-row" style={{ display: "block" }} data-testid={`zone-${z.id}`}>
            <div className="row">
              <button type="button" className="plain grow" style={{ textAlign: "left" }} onClick={() => onFocus(z.id)}>
                <strong>{t(`zone.${z.id}`)}</strong> <span className="hint">{`${z.rect.w}×${z.rect.h}`}</span>
              </button>
              <span className={`badge ${z.state === "open" ? "ok" : z.state === "reclaiming" ? "" : "dim"}`}>{t(`base.zones.state.${z.state}`)}</span>
            </div>
            {z.state === "locked" ? (
              <div className="row" style={{ marginTop: 6, gap: 10, flexWrap: "wrap" }}>
                {hqOk && z.cost ? <CostRow cost={z.cost} compact /> : <span className="hint"><FunctionalIcon name="lock" /> {t("base.build.locked", { n: z.unlockHq })}</span>}
                <span className="mono hint"><FunctionalIcon name="clock" /> {formatDuration(z.timeMs)}</span>
                <span className="grow" />
                <PayAction cost={hqOk && z.cost ? z.cost : {}} reasons={hqOk ? [] : ["locked"]} showReasons={false} onStart={(cover) => run(() => baseApi.reclaimZone(z.id, cover), t("base.toast.reclaiming"))} label={t("base.zones.reclaim")} testId={`reclaim-${z.id}`} style={{ marginTop: 0 }} />
              </div>
            ) : null}
            {z.state === "reclaiming" && z.finishesAt ? (
              <div className="row" style={{ marginTop: 6 }}>
                <span className="grow dim">{t("base.zones.reclaiming")}</span>
                <Timer finishesAt={z.finishesAt} className="timer" />
              </div>
            ) : null}
          </div>
        );
      })}
    </Sheet>
  );
}
